import { render } from "./textSection.vue?vue&type=template&id=4ff12974&scoped=true"
import script from "./textSection.vue?vue&type=script&lang=js"
export * from "./textSection.vue?vue&type=script&lang=js"

import "./textSection.vue?vue&type=style&index=0&id=4ff12974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff12974"]])

export default __exports__